import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminResetPassword from "@/pages/admin/AdminResetPassword";

export const Route = createFileRoute("/admin/reset-password")({
  head: () => pageHead("Admin \u2014 Reset Password \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminResetPassword,
});
